import { useGetPaginatedMonitoring } from '@/api/monitoring/monitoring.hooks';
import { FIRST_PAGE } from '@/views/DashboardView/components/EntitiesSection/components/EntitiesTable/utils/useDashboardTableQuery';
import { IGetPaginatedMonitoringResponse } from '@/api/monitoring/monitoring.types';

const ALERTS_COUNT_PAGE_SIZE = 1;

const selectTotal = (data: IGetPaginatedMonitoringResponse) => data.total;

export const useAlertsCountQuery = () => {
  const { fetchedPaginatedMonitoredEntities: alertsCount } = useGetPaginatedMonitoring(
    {
      entityTypes: null,
      allExtreme: true,
      displayName: null,
      sortBy: null,
      page: FIRST_PAGE,
      size: ALERTS_COUNT_PAGE_SIZE,
    },
    selectTotal,
  );

  return alertsCount;
};
